import { render, staticRenderFns } from "./RemoteOrder.vue?vue&type=template&id=044c0d1d&"
import script from "./RemoteOrder.vue?vue&type=script&lang=js&"
export * from "./RemoteOrder.vue?vue&type=script&lang=js&"
import style0 from "./RemoteOrder.vue?vue&type=style&index=0&id=044c0d1d&prod&language=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports